// Expected target is UI intent only. Access always comes from the server.
import { DISPLAY_OFFERS } from './planCatalog';
const key = 'stratify.pendingBillingUpgrade.v1';
export function rememberUpgrade(scope, offerKey, correlationId) {
  const offer = DISPLAY_OFFERS.find(o => o.offerKey === offerKey);
  if (!scope?.uid || !offer) return;
  try { sessionStorage.setItem(key, JSON.stringify({uid:scope.uid, projectId:scope.projectId,
    incarnation:scope.incarnation, offerKey, targetPlan:offer.planId, correlationId, at:Date.now()})); } catch {}
}
export function pendingUpgrade(scope) {
  try {
    const pending = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (!pending || !scope?.uid || pending.uid !== scope.uid || pending.projectId !== scope.projectId ||
        (pending.incarnation != null && scope.incarnation != null && pending.incarnation !== scope.incarnation) ||
        Date.now() - pending.at > 24*60*60*1000 || !['pro','elite'].includes(pending.targetPlan)) return null;
    return pending;
  } catch {return null;}
}
export function clearPendingUpgrade(scope) {
  if (pendingUpgrade(scope)) {try {sessionStorage.removeItem(key);} catch {}}
}
